import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQSection() {
  const {
    t
  } = useLanguage();
  const faqs = [{
    q: t('faq.q1'),
    a: t('faq.a1')
  }, {
    q: t('faq.q2'),
    a: t('faq.a2')
  }, {
    q: t('faq.q3'),
    a: t('faq.a3')
  }, {
    q: t('faq.q4'),
    a: t('faq.a4')
  }, {
    q: t('faq.q5'),
    a: t('faq.a5')
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 lg:py-28 bg-brand-cream" data-id="element-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="text-center mb-16" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-black mb-4" data-id="element-53">
            {t('faq.title')}
          </h2>
          <p className="text-lg text-brand-text/70" data-id="element-54">{t('faq.desc')}</p>
        </div>

        <div className="space-y-4" data-id="element-55">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-black/5 rounded-xl overflow-hidden shadow-sm" data-id="element-56">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-57">
                <span className="font-bold text-brand-black text-lg pr-8" data-id="element-58">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-brand-gold" data-id="element-59">
                  <ChevronDown className="w-6 h-6" data-id="element-60" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-61">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-62">
                    <div className="px-6 pb-6 text-brand-text/80 leading-relaxed border-t border-black/5 pt-4" data-id="element-63">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}